<div class="project-mas {{shadow=='0' ? '' : 'hover-shadow'}} {{gap=='0' ? '' : 'm-a30'}}">
    <div class="image-effect-one">
        <img [src]="data.image" [alt]="data.title || 'Photography by Vishwas Fotography'" loading="lazy" decoding="async" fetchpriority="low">
        <div class="figcaption">
            <a class="mfp-link" [href]="data.image" [attr.aria-label]="'Open ' + (data.title || 'photography image') + ' fullscreen'">
                <i class="fa fa-arrows-alt"></i>
            </a>
        </div>
    </div>
</div>
